'use strict';

import * as angular from 'angular';

var app = angular.module('noc');

app.controller('FleetDashboardController', require('./fleet-dashboard/fleet-dashboard'));
app.factory('FleetDashboardFactory', require('./fleet-dashboard/fleetDashboardFactory'));

app.controller('ContentStatisticsController', require('./portal/contentStatisticsController'));
app.factory('ContentStatisticsFactory', require('./portal/contentStatisticsFactory'));

app.factory('DashboardFactory', require('./shared/dashboardFactory'));

app.controller('TrainDashboardController', require('./train-dashboard/train-dashboard')); // not used anymore?
app.factory('TrainDashboardFactory', require('./train-dashboard/trainDashboardFactory'));

app.factory('TrainGridFactory', require('./trip/trainGridFactory'));
app.factory('TripDashboardFactory', require('./trip/tripDashboardFactory'));
app.controller('TripDashboardOverviewController', require('./trip/tripDashboardOverviewController'));
app.controller('TripDashboardSlaController', require('./trip/tripDashboardSlaController'));
app.constant('TripDashboardStatus', require('./trip/tripDashboardStatus'));

export default app;